<div color="primary" class="mat-toolbar" *ngIf="loginDisplay">
  <img
    src="../assets/images/defaults/iportal_logo_night.svg"
    class="toolbar-logo" />
  <div class="frame-right">
    <label class="switch">
      <input type="checkbox" (click)="switchMode()" disabled="true">
      <span class="slider round"></span>
    </label>
    <div class="localization">
      <div class="ellipse" [class.selectedlan]="selectedLanguage === 'jp'">
        <button type="button" (click)="switchLanguage()" 
          class="lang-text">{{'jp' | translate}}
        </button>
      </div>
      <div class="ellipse" [class.selectedlan]="selectedLanguage === 'en'">
        <button type="button" (click)="switchLanguage()"  
          class="lang-text">{{'EN' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<mat-sidenav-container [class.logged-in]="loginDisplay" [class.collapsed]="collapsed" >

  <mat-sidenav mode="side" [opened]="isSidenavOpened" *ngIf="loginDisplay" [class.mat-sidenav-night]="mode=='night'">
    <div class="sidenav-layout">
      <div class="sidenav-body">
        <button 
          class="create-claims-btn" 
          type="button"
          (click)="goToOpenCreateClaim()"
          [matTooltip]="collapsed ? ('createClaims' | translate) : ''"
          matTooltipPosition="right" 
          matTooltipClass="sidenav-tooltip" 
          [matTooltipShowDelay]="0"
        >
          <ng-container *ngIf="!collapsed">
            <img class="claims-bg" src="./assets/create-claims-icon.svg" />
            <span class="claims-text">{{ '+\t' + ('createClaims' | translate) }}</span>
          </ng-container>
          <img *ngIf="collapsed" class="img-collapsed" src="./assets/create-claims-collapsed.svg" />
        </button>
      
        <div class="sidenav-tab" (click)="goDashboardPage()" [class.selected]="selectedTab === 'dashboard'" [matTooltip]="collapsed ? ('home' | translate) : ''"
     matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
          <span>
            <mat-icon svgIcon="home" class="icon"></mat-icon>
            <span class="text" [class.text-night]="mode=='night'">{{ 'home' | translate }}</span>
          </span>
        </div>

        <div class="menu-section">
          <div class="section-title">
            <div class="text">
              {{ 'cs' | translate }}
            </div>  
          </div>

          <div class="menu-list">
            <div class="sidenav-tab" (click)="goClaimCenterPage()" [class.selected]="selectedTab === 'claim-center'" [matTooltip]="collapsed ? ('claimCenter' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span>
                <mat-icon svgIcon="claim-center" class="icon"></mat-icon>
                <span class="text">{{ 'claimCenter' | translate }}</span>
              </span>
            </div>
            <div class="sidenav-tab" (click)="goInquiryCenterPage()" [class.selected]="selectedTab === 'inquiry-center'" [matTooltip]="collapsed ? ('inquiryCenter' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span >
                <mat-icon svgIcon="inquiry-center" class="icon"></mat-icon>
                <span class="text">{{ 'inquiryCenter' | translate }}</span>
              </span>
            </div>
            <div class="sidenav-tab" (click)="goMeetingsPage()" [class.selected]="selectedTab === 'meetings'" [matTooltip]="collapsed ? ('meetings' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span>
                <mat-icon svgIcon="meetings" class="icon"></mat-icon>
                <span class="text">{{ 'meetings' | translate }}</span>
              </span>
            </div>
            <div class="sidenav-tab" (click)="goTroubleshootingPage()" [class.selected]="selectedTab === 'troubleshooting'" [matTooltip]="collapsed ? ('troubleshooting' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span>
                <mat-icon svgIcon="troubleshooting" class="icon"></mat-icon>
                <span class="text">{{ 'troubleshooting' | translate }}</span>
              </span>
            </div>
          </div>
        </div>
      
        <div class="menu-section">
          <div class="section-title">
            <div class="text">
              {{ 'db' | translate }}
            </div>  
          </div>
        
          <div class="menu-list">
            <div class="sidenav-tab" (click)="goCompanyPage()" [class.selected]="selectedTab === 'company'" [matTooltip]="collapsed ? ('companies' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span>
                <mat-icon svgIcon="company" class="icon"></mat-icon>
                <span class="text">{{ 'companies' | translate }}</span>
              </span>
            </div>
            <div class="sidenav-tab" (click)="goVesselPage()" [class.selected]="selectedTab === 'vessel'" [matTooltip]="collapsed ? ('vessels' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span>
                <mat-icon svgIcon="vessel" class="icon"></mat-icon>
                <span class="text">{{ 'vessels' | translate }}</span>
              </span>
            </div>
            <div class="sidenav-tab" (click)="goUserPage()" [class.selected]="selectedTab === 'user'" [matTooltip]="collapsed ? ('users' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span>
                <mat-icon svgIcon="user_select" class="icon"></mat-icon>
                <span class="text">{{ 'users' | translate }}</span>
              </span>
            </div>
            <div class="sidenav-tab" (click)="goEquipmentPage()" [class.selected]="selectedTab === 'equipment'" [matTooltip]="collapsed ? ('equipment' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span>
                <mat-icon svgIcon="equipment" class="icon"></mat-icon>
                <span class="text">{{ 'equipment' | translate }}</span>
              </span>
            </div>
            <div class="sidenav-tab" (click)="goTenantPage()" [class.selected]="selectedTab === 'tenant'" [matTooltip]="collapsed ? ('tenants' | translate) : ''"
              matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
              <span>
                <mat-icon svgIcon="tenant" class="icon"></mat-icon>
                <span class="text">{{ 'tenants' | translate }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="sidenav-footer">
        <div class="separator"></div>
        <div class="user-container" [class.user-container-night]="mode=='night'">
            <img class="profile-image" src="../assets/images/profile-image.png" [matTooltip]="collapsed ? userName : ''" matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0"/>
            <div class="user-info">
              <div class="user-name"  #nameEl [matTooltip]="nameEl.scrollWidth > nameEl.clientWidth ? userName : ''" matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">{{userName}}</div>
              <div class="user-email" #emailEl [matTooltip]="emailEl.scrollWidth > emailEl.clientWidth ? userEmail : ''" matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">{{userEmail}}</div>
            </div>

            <mat-icon svgIcon="exit" class="exit-icon" *ngIf="loginDisplay" (click)="logout()"></mat-icon>
        </div>
        <div class="sidenav-tab" (click)="minimizeMenu()" [matTooltip]="collapsed ? ('expandMenu' | translate) : ''"
          matTooltipPosition="right" matTooltipClass="sidenav-tooltip" [matTooltipShowDelay]="0">
          <span>
            <mat-icon [svgIcon]="collapsed ? 'expand-menu' : 'minimize-menu'" class="icon"></mat-icon>
            <span class="text" *ngIf="!collapsed">{{ 'minimizeMenu' | translate }}</span>
          </span>
        </div>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content [class.logged-in]="loginDisplay" [class.night]="mode=='night'">
    <div class="container">
      <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
      <div class="landing-page">
        <div class="home-logo" *ngIf="!loginDisplay">
          iPortal
        </div>
        <div class="login" *ngIf="!loginDisplay">
          <div class="welcome-text">Welcome to iPortal</div>
          <button mat-raised-button class="signinbtn" *ngIf="!loginDisplay" (click)="login()">&nbsp;サインイン / Sign in</button>
          <div class="infoceanus">
            <a target="_blank" class="redirect-infoceanus" href="https://infoceanus.com" rel="noreferrer">
                <img src="../assets/images/defaults/infoceanus.png">
            </a>
          </div>
        </div>
      </div>
      <!-- <button mat-raised-button *ngIf="loginDisplay" (click)="logout()">Logout</button> -->
      <router-outlet *ngIf="!isIframe"></router-outlet>
    </div>

    <div class="contents" style="overflow: scroll;">
      <router-outlet *ngIf="!isIframe"></router-outlet>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>